//The jsxRuntime pragma is necessary to get Emotion and React to work w/ latest Create-React-App version
/** @jsxRuntime classic */
/** @jsx jsx */
import styled from "@emotion/styled";

export const StyledTableContainer = styled.div`
    table {
        font-family: "Lato", sans-serif;

        width: 100%;
        background-color: #f0f2fd;
        text-align: center;
        color: #15357a;
        font-size: 14px;
        line-height: 17px;
        font-style: normal;
        font-weight: normal;
        border-collapse: collapse;
        border-radius: 5px;
        border-style: hidden; /* hide standard table (collapsed) border */
        box-shadow: 0 0 0 1px #e1ecff;

        margin-top: 1%;
        margin-bottom: 4%;
    }

    th {
        background-color: #e6eaff;
        font-weight: bold;
        height: 47px;
    }

    td,
    th {
        padding: 8px;
        height: 100%;
    }

    tr {
        height: 48px;
    }

    tr:nth-of-type(even) {
        background-color: #fafafa;
    }
`;
